import {PROJECT_FIND_ALL} from "../utils/Constant";

const projects = function (state = {}, action) {
  switch (action.type) {
    case PROJECT_FIND_ALL:

      return state;
    default :
      return state;
  }
}
export default projects;
